import React, { useState } from 'react'
import type {
  MarketingClippingCategory,
  MarketingClippingVehicle,
} from '../../types/marketing'
import ClippingBuscaAutomaticaTab from './ClippingBuscaAutomaticaTab'
import ClippingCadastroBasicoTab from './ClippingCadastroBasicoTab'

type ParametrosSubTab =
  | 'busca_clippings'
  | 'busca_alertas'
  | 'configuracoes_busca'
  | 'cadastro_basico'
type CatalogKind = 'veiculo' | 'categoria'
type CatalogSelectContext = 'search_config' | 'search_site'

interface ClippingParametrosTabProps {
  moduleName: string
  categorias: MarketingClippingCategory[]
  veiculos: MarketingClippingVehicle[]
  onVehiclesChange: (items: MarketingClippingVehicle[]) => void
  onCategoriesChange: (items: MarketingClippingCategory[]) => void
  onOpenCatalog: (kind: CatalogKind, context: CatalogSelectContext) => void
  pendingCatalogSelection: {
    kind: CatalogKind
    id: string
    context: CatalogSelectContext
  } | null
  onPendingCatalogSelectionConsumed: () => void
}

const subTabClass = (activeSubTab: ParametrosSubTab, tab: ParametrosSubTab) =>
  `py-3 px-1 border-b-2 font-medium text-sm ${
    activeSubTab === tab
      ? 'border-primary-600 text-primary-600 dark:text-primary-400'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
  }`

const ClippingParametrosTab: React.FC<ClippingParametrosTabProps> = ({
  moduleName,
  categorias,
  veiculos,
  onVehiclesChange,
  onCategoriesChange,
  onOpenCatalog,
  pendingCatalogSelection,
  onPendingCatalogSelectionConsumed,
}) => {
  const [activeSubTab, setActiveSubTab] = useState<ParametrosSubTab>('busca_clippings')

  return (
    <div>
      <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-8" aria-label="Subabas de parâmetros">
          <button
            type="button"
            onClick={() => setActiveSubTab('busca_clippings')}
            className={subTabClass(activeSubTab, 'busca_clippings')}
          >
            Busca de Clippings
          </button>
          <button
            type="button"
            onClick={() => setActiveSubTab('busca_alertas')}
            className={subTabClass(activeSubTab, 'busca_alertas')}
          >
            Busca de Alertas
          </button>
          <button
            type="button"
            onClick={() => setActiveSubTab('configuracoes_busca')}
            className={subTabClass(activeSubTab, 'configuracoes_busca')}
          >
            Configurações de busca
          </button>
          <button
            type="button"
            onClick={() => setActiveSubTab('cadastro_basico')}
            className={subTabClass(activeSubTab, 'cadastro_basico')}
          >
            Cadastro básico
          </button>
        </nav>
      </div>

      {activeSubTab === 'busca_clippings' && (
        <ClippingBuscaAutomaticaTab
          moduleName={moduleName}
          purpose="clipping"
          categorias={categorias}
          veiculos={veiculos}
          onOpenCatalog={onOpenCatalog}
          pendingCatalogSelection={pendingCatalogSelection}
          onPendingCatalogSelectionConsumed={onPendingCatalogSelectionConsumed}
        />
      )}

      {activeSubTab === 'busca_alertas' && (
        <ClippingBuscaAutomaticaTab
          moduleName={moduleName}
          purpose="alerta"
          categorias={categorias}
          veiculos={veiculos}
          onOpenCatalog={onOpenCatalog}
          pendingCatalogSelection={pendingCatalogSelection}
          onPendingCatalogSelectionConsumed={onPendingCatalogSelectionConsumed}
        />
      )}

      {activeSubTab === 'configuracoes_busca' && (
        <ClippingBuscaAutomaticaTab
          moduleName={moduleName}
          purpose="clipping"
          onlyPanel="configs"
          categorias={categorias}
          veiculos={veiculos}
          onOpenCatalog={onOpenCatalog}
          pendingCatalogSelection={pendingCatalogSelection}
          onPendingCatalogSelectionConsumed={onPendingCatalogSelectionConsumed}
        />
      )}

      {activeSubTab === 'cadastro_basico' && (
        <ClippingCadastroBasicoTab
          moduleName={moduleName}
          veiculos={veiculos}
          categorias={categorias}
          onVehiclesChange={onVehiclesChange}
          onCategoriesChange={onCategoriesChange}
        />
      )}
    </div>
  )
}

export default ClippingParametrosTab
